export default __webpack_public_path__ + "static/media/shield-green.8d5e6ffa.svg";